import React, { useState } from "react";
import { Modal, Form, Select, Checkbox, Button, message } from "antd";
import "../../styles/components/facultyProfile/modal.scss";
import useAcademicTerms from "../../hooks/useAcademicTerms";

const workloadOptions = [
  { label: "Teaching Load In UPOU", value: "teaching_load_upou" },
  { label: "Teaching Load In Other UP Units", value: "teaching_load_other_up" },
  { label: "Teaching Load Outside UP", value: "teaching_load_outside_up" },
  {
    label: "Research, Textbook Writing, Course Dev., & Creative Work",
    value: "research",
  },
  { label: "Administrative Work", value: "administrative_work" },
  { label: "Tutorial Work", value: "tutorial_work" },
  { label: "Extension Service", value: "extension_service" },
];

export default function GeneratePortfolioModal({ open, onSubmit, onCancel }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const termOptions = useAcademicTerms();

  const allValues = workloadOptions.map((item) => item.value);

  const selectedSections = Form.useWatch("sections", form) || [];

  const checkAll = selectedSections.length === allValues.length;
  const indeterminate =
    selectedSections.length > 0 && selectedSections.length < allValues.length;

  const handleGenerate = async () => {
    try {
      setLoading(true);

      const values = await form.validateFields();
      await onSubmit?.(values);
    } catch (errorInfo) {
      message.error("Please fill out the fields correctly.");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckAll = (e) => {
    form.setFieldsValue({
      sections: e.target.checked ? allValues : [],
    });
  };

  return (
    <Modal
      className="modal"
      title="Generate Portfolio"
      open={open}
      onCancel={onCancel}
      destroyOnClose
      afterOpenChange={(open) => {
        if (!open) form.resetFields();
      }}
      footer={null}
      modalRender={(modal) => (
        <div
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          {modal}
        </div>
      )}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="academic_terms" label="Academic Terms">
          <Select
            mode="multiple"
            allowClear
            placeholder="All terms"
            options={termOptions}
            maxTagCount={1}
          />
        </Form.Item>

        <Form.Item label="Sections" required>
          <div
            style={{
              border: "1px solid lightgray",
              padding: "5px 10px",
              borderRadius: 6,
            }}
          >
            <Checkbox
              indeterminate={indeterminate}
              checked={checkAll}
              onChange={handleCheckAll}
            >
              Select all
            </Checkbox>

            <div
              style={{
                borderBottom: "1px solid lightgray",
                paddingBottom: 5,
                marginBottom: 5,
              }}
            ></div>

            <Form.Item
              name="sections"
              noStyle
              rules={[
                {
                  required: true,
                  message: "Select at least one.",
                },
              ]}
            >
              <Checkbox.Group
                options={workloadOptions}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 5,
                }}
              />
            </Form.Item>
          </div>
        </Form.Item>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 20,
          }}
        >
          <Button
            type="primary"
            style={{ background: "#008767" }}
            onClick={handleGenerate}
            loading={loading}
          >
            Generate
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
